import React from "react";

/** Match http(s) URLs; trim trailing punctuation often glued to links. */
const URL_RE = /https?:\/\/[^\s<>"'`]+/gi;

function trimTrailingPunctuation(url) {
  let cleaned = url;
  let trailing = "";
  while (cleaned && /[.,;:!?)\]}'"]$/.test(cleaned)) {
    trailing = cleaned.slice(-1) + trailing;
    cleaned = cleaned.slice(0, -1);
  }
  return { url: cleaned, trailing };
}

/**
 * Rende il testo con URL http(s) come link cliccabili.
 * @param {string} text
 * @param {string} [className]
 * @returns {React.ReactNode}
 */
export function linkifyText(text, className = "text-teal-700 underline underline-offset-2 hover:text-teal-900 break-all") {
  if (!text) return null;
  const parts = [];
  let lastIndex = 0;
  const source = String(text);
  const re = new RegExp(URL_RE.source, URL_RE.flags);
  let match;
  let key = 0;

  while ((match = re.exec(source)) !== null) {
    if (match.index > lastIndex) {
      parts.push(source.slice(lastIndex, match.index));
    }
    const { url, trailing } = trimTrailingPunctuation(match[0]);
    if (url) {
      parts.push(
        <a
          key={`link-${key++}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
        >
          {url}
        </a>
      );
    }
    if (trailing) {
      parts.push(trailing);
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < source.length) {
    parts.push(source.slice(lastIndex));
  }

  return parts.length === 1 && typeof parts[0] === "string" ? parts[0] : parts;
}
